/**
 * @generated SignedSource<<1dfb29e3d5eaf531caa8b7917bc0fb1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MaintenanceToggleButton_Fragment$data = {
  readonly id: string;
  readonly isUpdating: boolean;
  readonly " $fragmentType": "MaintenanceToggleButton_Fragment";
};
export type MaintenanceToggleButton_Fragment$key = {
  readonly " $data"?: MaintenanceToggleButton_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MaintenanceToggleButton_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MaintenanceToggleButton_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUpdating",
      "storageKey": null
    }
  ],
  "type": "MaintenanceUpdate",
  "abstractKey": null
};

(node as any).hash = "82b08ef718b0519b3b041d12ac035fcd";

export default node;
